import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Link, Typography} from '@mui/material';
import {LegalPage, Section} from '../components/layouts/LegalPage';
import {CONTACT_EMAIL} from './PrivacyPolicyPage';

// How to delete an account and its data, at /delete-account: a page that needs no sign-in, so someone who cannot (or no longer wants to)
// use the app can still ask. Google Play asks every app that creates accounts for a public page like this.
export default function DeleteAccountInfoPage() {
    return (
        <LegalPage title="Delete your Task Kiosk account" updated="13 October 2026">
            <Section title="In the app (the quickest way)">
                <ol>
                    <li>Sign in and open <strong>Account</strong> from the menu at the top right.</li>
                    <li>Scroll to <strong>Delete account</strong> and choose <strong>Delete my account…</strong></li>
                    <li>Enter your password and confirm. The deletion happens at once.</li>
                </ol>
            </Section>

            <Section title="By email, if you cannot sign in">
                <Typography paragraph>
                    Email <Link href={`mailto:${CONTACT_EMAIL}?subject=Delete%20my%20Task%20Kiosk%20account`}>{CONTACT_EMAIL}</Link> from the
                    address on the account, with the subject &quot;Delete my Task Kiosk account&quot;. We delete it within 30 days and reply when it is done.
                </Typography>
            </Section>

            <Section title="What is deleted">
                <ul>
                    <li>Your account (email address, password hash, name) and your email settings.</li>
                    <li>Every board you own, with its tasks, history, kiosk note and photos, and so also what other people had on those boards.</li>
                    <li>Your place on other people&apos;s boards, your invitations and your notifications.</li>
                </ul>
            </Section>

            <Section title="What may remain">
                <ul>
                    <li>Things other people&apos;s boards recorded about you by internal number only, such as which task you completed.</li>
                    <li>Usage events (&quot;a task was completed&quot;) that carry only internal numbers and no name or email address, and logs, for a limited time.</li>
                    <li>Copies in our service providers&apos; backups, for a limited time.</li>
                </ul>
            </Section>

            <Typography paragraph sx={{mt: 3}}>
                More about what we collect and why is in the <Link component={RouterLink} to="/privacy">privacy policy</Link>.
            </Typography>
        </LegalPage>
    );
}
